import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { Bundle } from '_core/util';
import { tokenEmailApi as API } from '../Apis';
import { GenerateEmailTokenType } from '../Types/GenerateTokenEmailTypes';
import { ValidateTokenEmailTypes } from '../Types';

export const ValidateTokenEmailDocs: IDocs = {
  title: 'ValidateTokenEmail',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.validateTokenEmail',
};

const prepareCall = (
  stateRequestParameters: ValidateTokenEmailTypes.ValidateTokenEmailServiceRequestType,
) =>
  API.call.get({
    type: GenerateEmailTokenType[stateRequestParameters.tokenType],
    token: stateRequestParameters.token,
  });

const handleSucessFinalResponseFunction = (data: any) => {
  if (data?.smilesToken) Bundle.setValue('smilesToken', data?.smilesToken);
  return data;
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const tokenExpired = infos?.tokenExpired;
  const smilesErrorService =
    infos?.errorService || infos?.processFailure || !tokenExpired;

  return { tokenExpired, smilesErrorService };
};

export const ValidateTokenEmailMachine = GenericMachine(
  prepareCall,
  {
    docs: ValidateTokenEmailDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
    handleErrorFlowFinalResponseFunction,
  },
);
